import Page from '@/components/Page'
import SearchBar from '@/components/Search/SearchBar'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(test)/test/search')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<Page>
			<SearchBar />
		</Page>
	)
}
